import { render, staticRenderFns } from "./CommonChartsAdapter.vue?vue&type=template&id=6bca4533&scoped=true"
import script from "./CommonChartsAdapter.vue?vue&type=script&lang=js"
export * from "./CommonChartsAdapter.vue?vue&type=script&lang=js"
import style0 from "./CommonChartsAdapter.vue?vue&type=style&index=0&id=6bca4533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bca4533",
  null
  
)

export default component.exports